/**
 * Cache System Index - IPHUB Project
 * Main entry point for cache system with ESM structure
 */

// Export configuration
export {
  DEFAULT_CONFIG,
  TTL,
  STORAGE,
  PREFIXES,
  ERROR_MESSAGES,
  DEBUG_MESSAGES,
  createConfig,
  validateConfig,
} from "./config.js";

// Export utilities
export {
  checkStorageAvailability,
  calculateCurrentSize,
  generateKey,
  createCacheItem,
  isExpired,
  calculateItemSize,
  formatDebugMessage,
  logDebug,
  logWarning,
  logError,
  collectCacheKeys,
  removeCacheKeys,
  parseCacheItem,
  validateCacheItem,
  getCacheStats,
} from "./utils.js";

// Export statistics
export {
  getStats,
  incrementHits,
  incrementMisses,
  incrementSets,
  incrementDeletes,
  incrementCleanups,
  incrementErrors,
  resetStats,
  calculateHitRate,
  getDetailedStats,
  exportStats,
  importStats,
} from "./statistics.js";

// Export main cache manager
export { SimpleCacheManager } from "./simple-cache-manager.js";

// Create and export singleton instance
import { SimpleCacheManager } from "./simple-cache-manager.js";
const simpleCacheManager = new SimpleCacheManager();

// Export singleton as default
export default simpleCacheManager;

// Export factory function for creating custom instances
export const createCacheManager = (config = {}) => new SimpleCacheManager(config);

// Export convenience functions
export const getCache = () => simpleCacheManager;
export const getCacheInfo = () => simpleCacheManager.getInfo();
export const resetCacheStats = () => simpleCacheManager.resetStats();
